/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryDiseasesCreateAliases {
  AUTOCOMPLETE_PATHOLOGIE = 'autocomplete-pathologie',
  AUTOCOMPLETE_SECURITYLEVEL = 'autocomplete-securitylevel',
  AUTOCOMPLETE_SITUATION = 'autocomplete-situation',
  CHECKBOX_DENIES_DISEASES = 'checkbox-denies-diseases',
  CHECKBOX_DISPLAY_PATIENT_ALERTS = 'checkbox-display-patient-alerts',
  CHECKBOX_INSERT_DIAGNOSIS_LIST = 'checkbox-insert-diagnosis-list',
  CHECKBOX_INSERT_PROBLEMS_LIST = 'checkbox-insert-problems-list',
  CONTEXTUAL_BAR_BODY = 'contextual-bar-body',
  DATE_FIELD_END_DATE = 'date-field-end-date',
  DATE_FIELD_START_DATE = 'date-field-start-date',
  FETCH_CID = 'fetch-cid',
  FETCH_PATHOLOGIE = 'fetch-pathologie',
  FETCH_SAE = 'fetch-sae',
  FETCH_SECURITYLEVEL = 'fetch-securitylevel',
  FETCH_SITUATION = 'fetch-situation',
  FIELD_APPROACH = 'field-approach',
  FIELD_CID = 'field-cid',
  FIELD_DENIES_DISEASES = 'field-denies-diseases',
  FIELD_DISEASEFREE = 'field-diseasefree',
  FIELD_DISPLAY_PATIENT_ALERTS = 'field-display-patient-alerts',
  FIELD_END_DATE = 'field-end-date',
  FIELD_HIGHLIGHT_INTENSITY_SEVERITY = 'field-highlight-intensity-severity',
  FIELD_INSERT_DIAGNOSIS_LIST = 'field-insert-diagnosis-list',
  FIELD_INSERT_PROBLEMS_LIST = 'field-insert-problems-list',
  FIELD_NOTES = 'field-notes',
  FIELD_PATHOLOGIE = 'field-pathologie',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_SAE = 'field-sae',
  FIELD_SECURITYLEVEL = 'field-securitylevel',
  FIELD_SITUATION = 'field-situation',
  FIELD_START_DATE = 'field-start-date',
  FORM_ONE = 'form-one',
  FORM_THREE = 'form-three',
  FORM_TWO = 'form-two',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_CID = 'input-cid',
  INPUT_DISEASESFREE = 'input-diseasesfree',
  INPUT_RECORD_DATE = 'input-record-date',
  INPUT_SAE = 'input-sae',
  LAYOUT_HEALTH_HISTORY_DISEASES_CREATE = 'layout-health-history-diseases-create',
  LOCATOR_CID = 'locator-cid',
  LOCATOR_FIELD_CID = 'locator-field-cid',
  LOCATOR_FIELD_SAE = 'locator-field-sae',
  LOCATOR_SAE = 'locator-sae',
  MAPPER_PATHOLOGIE = 'mapper-pathologie',
  MAPPER_SECURITYLEVEL = 'mapper-securitylevel',
  MAPPER_SITUATION = 'mapper-situation',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  RADIO_GROUP_HIGHLIGHT_INTENSITY_SEVERITY = 'radio-group-highlight-intensity-severity',
  TEXT_AREA_APPROACH = 'text-area-approach',
  TEXT_AREA_NOTE = 'text-area-note',
  TEXT_PATHOLOGIE = 'text-pathologie',
  TEXT_SECURITYLEVEL = 'text-securitylevel',
  TEXT_SITUATION = 'text-situation',
  WIZARD = 'wizard',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_THREE = 'wizard-step-three',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { HealthHistoryDiseasesCreateAliases };
